import userSlice from "./slices/userSlice";
import { configureStore } from "@reduxjs/toolkit";
import sessionSlice from "./slices/sessionSlice";
import sessionMenssageSlice from "./slices/sessionMenssageSlice";
import sessionMetadataSlice from "./slices/sessionMetadataSlice";
import sessionProductsSlice from "./slices/sessionProductsSlice";
import sessionClassificationsSlice from "./slices/sessionClassificationsSlice";
import sessionFavoritesSlice from "./slices/sessionFavorite";
import sessionClassificationsMessageSlice from "./slices/sessionClassificationsMessageSlice";
import sessionCenterSlice from "./slices/sessionCenterSlice";
import sessionGroupsSlice from "./slices/sessionGroupsSlice";
import sessionGroupRulesSlice from "./slices/sessionGroupRulesSlice";
import sessionGroupParticipantsSlice from "./slices/sessionGroupParticipantsSlice";

const store = configureStore({
  reducer: {
    user: userSlice,
    sessionInfo: sessionSlice,
    sessionMessage: sessionMenssageSlice,
    sessionMetadata: sessionMetadataSlice,
    sessionProducts: sessionProductsSlice,
    sessionCenter: sessionCenterSlice,
    sessionClassifications: sessionClassificationsSlice,
    sessionFavorite: sessionFavoritesSlice,
    sessionClassificationsMessage: sessionClassificationsMessageSlice,
    sessionGroups: sessionGroupsSlice,
    sessionGroupRules: sessionGroupRulesSlice,
    sessionGroupParticipants: sessionGroupParticipantsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
